
var indexReports = ['hse', 'placement', 'litnum', 'certification'];

module.config(function($stateProvider) {

    $stateProvider.state('reports.index', {
        url: '',
        templateUrl: 'reports/index',
        controller: 'ReportIndexController',
        permission: 'viewReports',
    });

    $stateProvider.state('program.reports.index', {
        url: '',
        templateUrl: 'reports/index',
        controller: 'ReportIndexController',
        permission: 'viewReports',
    });
});

module.cC({
    name: 'ReportIndexController',
    inject: ['$scope', '$timeout', 'moment'],
    init: function() {
        var scope = this.$;
        this.$.reportYear = this.moment().year();
        this.$.viewDetails = (!scope.program || scope.permissions.viewStudents);
    },
});
